import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Tên nhóm", -1)
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Tạo nhóm", -1)
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tài khoản", -1)
const _hoisted_9 = { class: "card flex justify-content-center" }
const _hoisted_10 = { class: "flex align-items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { style: {"width":"20px"} }
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nhóm", -1)
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Thêm thành viên", -1)
const _hoisted_17 = { class: "p-fluid" }
const _hoisted_18 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_19 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Không có thông tin nhân viên. ")
const _hoisted_21 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_22 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tài khoản", -1)
const _hoisted_24 = { class: "card flex justify-content-center" }
const _hoisted_25 = { class: "flex align-items-center" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { style: {"width":"20px"} }
const _hoisted_28 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "Chọn nhóm", -1)
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Thêm quản lý", -1)
const _hoisted_32 = { class: "p-fluid" }
const _hoisted_33 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_34 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Không có thông tin quản lý. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock(_component_Accordion, {
    activeIndex: $setup.activeIndex,
    "onUpdate:activeIndex": _cache[12] || (_cache[12] = ($event: any) => (($setup.activeIndex) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AccordionTab, { header: "Thêm nhóm" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                id: "firstname",
                type: "text",
                modelValue: $setup.group.groupName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.group.groupName) = $event)),
                placeholder: "Tên nhóm"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Button, {
                label: "Tạo",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.createGroup())),
                disabled: !$setup.group.groupName
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_AccordionTab, { header: "Thêm nhân viên vào nhóm" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Dropdown, {
                  modelValue: $setup.member.idZalo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.member.idZalo) = $event)),
                  options: $setup.listCustomer,
                  optionLabel: "name",
                  optionValue: "id",
                  placeholder: "Chọn tài khoản",
                  filter: true,
                  class: "w-full md:w-14rem"
                }, {
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_10, [
                      (slotProps.option.imageUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: slotProps.option.imageUrl,
                            style: {"width":"20px","margin-right":"3px"}
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", _hoisted_12, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.member.idGroup,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.member.idGroup) = $event)),
                options: $setup.listGroup,
                optionLabel: "groupName",
                optionValue: "id",
                placeholder: "Chọn nhóm",
                filter: true,
                onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.getListMemberInGroup($setup.member.idGroup)))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_Button, {
                label: "Thêm",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.createMember())),
                disabled: !$setup.member.idZalo||!$setup.member.idGroup
              }, null, 8, ["disabled"])
            ])
          ]),
          _createVNode(_component_Panel, { header: "Danh sách nhân viên trong nhóm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_DataTable, {
                  value: $setup.listMember,
                  paginator: true,
                  stripedRows: "",
                  rows: 10,
                  rowsPerPageOptions: [10,25,50],
                  rowHover: true,
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: ['zaloName','groupName'],
                  currentPageReportTemplate: "Có tất cả {totalRecords} nhân viên",
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters) = $event))
                }, {
                  paginatorLeft: _withCtx(() => []),
                  empty: _withCtx(() => [
                    _hoisted_20
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "zaloName",
                      header: "Tên",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "groupName",
                      header: "Nhóm",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, { header: "Tuỳ chọn" }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_Button, {
                              type: "button",
                              class: "p-button-danger",
                              label: "Xoá",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => ($setup.deleteMember(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_AccordionTab, { header: "Thêm quản lý của nhóm" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_Dropdown, {
                  modelValue: $setup.manager.idZalo,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.manager.idZalo) = $event)),
                  options: $setup.listCustomer,
                  optionLabel: "name",
                  optionValue: "id",
                  placeholder: "Chọn tài khoản",
                  filter: true,
                  class: "w-full md:w-14rem"
                }, {
                  option: _withCtx((slotProps) => [
                    _createElementVNode("div", _hoisted_25, [
                      (slotProps.option.imageUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: slotProps.option.imageUrl,
                            style: {"width":"20px","margin-right":"3px"}
                          }, null, 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      _createElementVNode("label", _hoisted_27, _toDisplayString(slotProps.option.name), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.manager.idGroup,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.manager.idGroup) = $event)),
                options: $setup.listGroup,
                optionLabel: "groupName",
                optionValue: "id",
                placeholder: "Chọn nhóm",
                filter: true,
                onChange: _cache[9] || (_cache[9] = ($event: any) => ($setup.getListManagerOfGroup($setup.manager.idGroup)))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createVNode(_component_Button, {
                label: "Thêm",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.createManager())),
                disabled: !$setup.manager.idZalo||!$setup.manager.idGroup
              }, null, 8, ["disabled"])
            ])
          ]),
          _createVNode(_component_Panel, { header: "Danh sách quản lý nhóm" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_DataTable, {
                  value: $setup.listManager,
                  paginator: true,
                  stripedRows: "",
                  rows: 10,
                  rowsPerPageOptions: [10,25,50],
                  rowHover: true,
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: ['zaloName','groupName'],
                  currentPageReportTemplate: "Có tất cả {totalRecords} quản lý",
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters) = $event))
                }, {
                  paginatorLeft: _withCtx(() => []),
                  empty: _withCtx(() => [
                    _hoisted_35
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "zaloName",
                      header: "Tên",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, {
                      field: "groupName",
                      header: "Nhóm",
                      sortable: ""
                    }),
                    _createVNode(_component_Column, { header: "Tuỳ chọn" }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_component_Button, {
                              type: "button",
                              class: "p-button-danger",
                              label: "Xoá",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => ($setup.deleteManager(slotProps.data.id))
                            }, null, 8, ["onClick"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["activeIndex"]))
}